import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {Group} from '../../graphql/groups.datatypes';

interface GroupTourRolesData {
    groupByRef: void
    groupTourRoles: Group
}


export const gqlGroupTourRoles = `
    id

    tour {
      id
      tour_roles {
        id
        tour_role
      }
    }
`;

export const GET_GROUP_TOUR_ROLES_QUERY = gql`
    query getGroupTourRoles($id: Int!){
        groupTourRoles(id: $id){
            ${gqlGroupTourRoles}
        }
    }
`;

export const getGroupTourRoles = (groupId: number | null) => {
    const id = groupId ? groupId : -1;
    return useQuery<GroupTourRolesData>(
        GET_GROUP_TOUR_ROLES_QUERY,
        {
            variables: {id},

        }
    );
};

export default getGroupTourRoles;
